export const RECORDINGS_STORE_NAME = 'student-assessment-recordings';

export const INFO_DATA = 'info-data';
export const RESULTS_STORE_NAME = 'results';
export const CONTENT_STORE_NAME = 'content';
